import  { createContext } from "react";

export const MusicPlayerContext = createContext();
